import * as React from 'react';
import { ReactElement } from 'react';
import styled from 'styled-components';
import { Typography } from '../../figma/DesignSystemV2/Typography';
import { Button } from '../../figma/ButtonV2/ButtonV2';
import { colorsV2 } from '../../figma/colors-v2';
import { Link } from '../../figma/Link';

const ColorButton = styled(Button.Primary)<{ color?: string }>`
  min-width: 200px;
  &.type-primary {
    background-color: ${(props) => props.color || colorsV2.blue100};
    :hover {
      background-color: ${(props) => props.color || colorsV2.blue100};
    }
  }
`;
const LeftSection = styled.div`
  display: grid;
  text-align: center;

  .description {
    margin-top: 12px;
  }
`;
const RightSection = styled.div``;
const DolPremiumWrapper = styled.div<{ color?: string }>`
  background-color: ${(props) => props.color || colorsV2.blue10};
  display: flex;
  border-radius: 8px;
  padding: 32px;
  flex-direction: column;
  align-items: center;

  ${RightSection} {
    margin-top: 24px;
  }
`;

interface DolPremiumBannerProps {
  backgroundColor: string;
  title: string;
  description: ReactElement;

  actionTitle: string;
  actionHref?: string;
  actionOnClick?: () => void;
  actionBackgroundColor: string;

  hrefOptions?: any;
}

const Action = ({ actionBackgroundColor, actionHref, actionOnClick, actionTitle, hrefOptions }) => {
  if (actionOnClick) {
    return (
      <ColorButton color={actionBackgroundColor} onClick={actionOnClick}>
        {actionTitle}
      </ColorButton>
    );
  }

  if (actionHref) {
    return (
      <Link href={actionHref} {...hrefOptions}>
        <ColorButton color={actionBackgroundColor}>{actionTitle}</ColorButton>
      </Link>
    );
  }

  return null;
};

export const DolPremiumVerticalBanner = ({
  backgroundColor,
  title,
  description,
  actionTitle,
  actionOnClick,
  actionHref,
  actionBackgroundColor,
  hrefOptions,
}: DolPremiumBannerProps) => {
  return (
    <DolPremiumWrapper color={backgroundColor}>
      <LeftSection>
        <Typography.Text className="title" variant="bold/32" color="black100">
          {title}
        </Typography.Text>
        <Typography.Text className="description" variant="regular/16-24" color="black80">
          {description}
        </Typography.Text>
      </LeftSection>
      <RightSection>
        <Action
          actionOnClick={actionOnClick}
          actionBackgroundColor={actionBackgroundColor}
          actionHref={actionHref}
          actionTitle={actionTitle}
          hrefOptions={hrefOptions}
        />
      </RightSection>
    </DolPremiumWrapper>
  );
};
